module.exports = __webpack_public_path__ + "img/tower.c901c012.png";